import { createSlice } from "@reduxjs/toolkit";
import { loadState } from "../LocalStorage/LocalStorage";

export const initialUserState = loadState("user", {
    access_token: "",
    user: ""
})

const UserSlice = createSlice({
    name: "Users",
    initialState: initialUserState,

    reducers: {

        setUser(state, action) {
            const user = action.payload
            state.user = user || {}
        },

        setAccessToken(state, action) {
            const access_token = action.payload
            state.access_token = access_token || ""
        },

        setBrandAccount(state, action) {
            const { account, isAdmin, feedbackData, contactId } = action.payload;
            state.brandAccount = {
                ...account,
                isAdmin: isAdmin ,
                feedbackData: feedbackData, // Add new key while keeping existing data
                contactId: contactId // Store contact_id from selected business
            };
        },

//         setBusinessExist(state, action) {
// const businessExist = action.payload;
//         },

        setTickets(state, action) {
            const ticketList = action.payload
            state.ticketList = ticketList || {}
        },

        setCategories(state, action) {
            const category = action.payload
            state.category = category || []
        },

        setCreatedNewTicket(state, action) {
            const newTicket = action.payload
            state.newTicket = newTicket || {}
        },

        setBusinessData(state, action) {
            const business = action.payload
            state.business = business || {}
        }

    }
})

export const { setUser, setAccessToken, setBrandAccount, setTickets, setCategories, setCreatedNewTicket, setBusinessData } = UserSlice.actions;

export default UserSlice;